const common =
  '[&::-webkit-scrollbar]:h-[10px] [&::-webkit-scrollbar]:w-[10px] [&::-webkit-scrollbar-track]:bg-transparent focus:visible hover:visible'
const dark = `${common} [&::-webkit-scrollbar-thumb]:bg-cloudy-blue-alpha-20 [&::-webkit-scrollbar-thumb:hover]:bg-cloudy-blue-alpha-50`
const light = `${common} [&::-webkit-scrollbar-thumb]:bg-cloudy-blue-light [&::-webkit-scrollbar-thumb:hover]:bg-cloudy-blue`

export { dark, light }
